import { IconButton, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Grid from "@mui/material/Grid";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import { useState } from "react";
import AddMenuDropdown from "./addMenuDropdown";
import {NativeSelect} from '@mui/material';
import {InputLabel} from "@mui/material";
import {FormControl} from '@mui/material';
import storage from "../firebaseConfig2";
import {
    ref,
    uploadBytesResumable,
    getDownloadURL 
} from "firebase/storage";
import { database } from "../firebaseConfig2";
import {push,child,update} from "firebase/database";
import { collection, doc, setDoc } from "firebase/firestore"; 



function AddMenu(props) {
    const [submitType, setSubmitType] = useState("string");
    const [quote, setQuote] = useState("");
    const [file, setFile] = useState("");
    const [percent, setPercent] = useState(0);
    const [uploadedImageURL, setUploadedImageURL] = useState("");

    const [currentlyCraving, setCurrentlyCraving] = useState("");
    const [currentlyLearning, setCurrentlyLearning] = useState("");
    const [currentlyPlaying, setCurrentlyPlaying] = useState("");
    const [currentlyReading, setCurrentlyReading] = useState("");
    const [currentlyWatching, setCurrentlyWatching] = useState("");

    const [blorboName, setBlorboName] = useState("");
    const [blorboOrigin, setBlorboOrigin] = useState("");
    const [blorboOriginLink, setBlorboOriginLink] = useState("");


    //submit either image or text

    const handleSubmit  = () => {
            let mydate = Date.now();
            const quotesRef= doc(database, props.tableName, mydate.toString());
             if (props.tableName == "statuses"){
                if (submitType == "string"){

                    try {
                        const result =  setDoc(quotesRef, {
                            message : quote,
                            type:submitType,
                            date: mydate
                    });
                    console.log("Docuent successfully written!");
                    }
                    catch (error) {
                        console.error("Error adding document: ", error);
                    }
                }
                 else{
                    let mydate = Date.now();
                    const quotesRef= doc(database, props.tableName, mydate.toString());
                    setDoc(quotesRef, {
                        message : uploadedImageURL,
                        type:submitType,
                        date: mydate
                        
                    });     
                }

            }
            if (props.tableName == "currently_i_am"){
                console.log("currently_i_am submit");
                 try {
                    const result =  setDoc(quotesRef, {
                    date: mydate,
                    craving: currentlyCraving,
                    learning: currentlyLearning,
                    playing: currentlyPlaying,
                    reading: currentlyReading,
                    watching: currentlyWatching
                });
                console.log("Docuent successfully written!");

                } 
                catch (error) {
                    console.error("Error adding document: ", error);
                }

            }

            if (props.tableName == "mkcp_blorbos"){
                 let mydate = Date.now();
                const quotesRef= doc(database, props.tableName, mydate.toString());
                setDoc(quotesRef, {
                        img : uploadedImageURL,
                        date: mydate,
                        message : quote,
                        name: blorboName,
                        origin: blorboOrigin,
                        origin_link: blorboOriginLink
                });     
            }
            
        
            props.triggerUpdate(props.updater + 1);
        }

     // Handle file upload event and update state
     function handleChange(event) {
        setFile(event.target.files[0]);
    }
    
    const handleUpload = () => {
        if (!file) {
            alert("Please upload an image first!");
        }
        console.log('uploading...');
        const storageRef = ref(storage, `/mkcp-images/${file.name}`);
 
        // progress can be paused and resumed. It also exposes progress updates.
        // Receives the storage reference and the file to upload.
        const uploadTask = uploadBytesResumable(storageRef, file);
 
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const percent = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );
 
                // update progress
                setPercent(percent);
            },
            (err) => console.log(err),
            () => {
                // download url
                getDownloadURL(uploadTask.snapshot.ref).then((url) => {
                    setUploadedImageURL(url);
                });
            }
        );
    };
    // ----------BEGIN HTML-------------
    return (
        
        <div className="addmenu-container">
            {/* --------- HEADER -------- */}
            <div className="addmenu-header">
                <h2 id="menutitle">New Entry</h2>
                <IconButton id="menucloser" onClick={() => props.setAddMenu(false)}>
                    <CloseIcon />
                </IconButton>
            </div>
            {/* --------- BEGIN FORM -------- */}
            <div className="addmenu-form">
                { props.tableName == "statuses" &&
                <Grid container spacing={2}>
                
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                Entry type
                            </InputLabel>

                            {/* --------- DROPDOWN -------- */}
                            <NativeSelect
                                onChange={(e)=>setSubmitType((e.target.value))}
                                defaultValue={"string"}
                                inputProps={{
                                name: 'entry-type',
                                id: 'uncontrolled-native',
                                }}
                            >
                                <option value={"string"}>String</option>
                                <option value={"image"}>Image</option>
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setQuote(e.target.value)}
                                value = {quote.toString()}
                                required
                                fullWidth
                                id="input"
                                label="Message input"
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            <div className="character-counter">
                                {280 - quote.length}
                            </div>
                    </div>
                    {/* --------- IMAGE FIELD -------- */}
                    <div className="imgfield" style={{ display: (submitType == "image") ? 'block' : 'none' }}>
                        <input type="file" onChange={handleChange} accept="" />
                        <button onClick={() => handleUpload(file,percent)}>Upload to Firebase</button>
                        <p>{percent} "% done"</p>
                    </div>
                    
                       
                    </Grid>
                    </Grid>
                    }
                { props.tableName == "currently_i_am" &&
                <Grid container spacing={2}>
                
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setCurrentlyCraving(e.target.value)}
                                value = {currentlyCraving.toString()}
                                fullWidth
                                id="input"
                                label="Currently craving..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            
                    </div>
                       
                    </Grid>
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setCurrentlyLearning(e.target.value)}
                                value = {currentlyLearning.toString()}
                                fullWidth
                                id="input"
                                label="Currently learning..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            
                    </div>
                       
                    </Grid>
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setCurrentlyPlaying(e.target.value)}
                                value = {currentlyPlaying.toString()}
                                fullWidth
                                id="input"
                                label="Currently playing..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            
                    </div>
                       
                    </Grid>
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setCurrentlyReading(e.target.value)}
                                value = {currentlyReading.toString()}
                                fullWidth
                                id="input"
                                label="Currently reading..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            
                    </div>
                       
                    </Grid>
                    <Grid item xs={12}> 
                        {/* --------- TEXT FIELD -------- */}
                        <div className="textfield" style={{ display: (submitType == "string") ? 'block' : 'none' }}>
                            <TextField
                                onChange={(e) => setCurrentlyWatching(e.target.value)}
                                value = {currentlyWatching.toString()}
                                fullWidth
                                id="input"
                                label="Currently watching..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                            
                    </div>
                       
                    </Grid>
                    </Grid>
                    }
{ props.tableName == "mkcp_blorbos" &&
                <Grid container spacing={2}>
                    <Grid item xs={12}> 
                        {/* --------- IMAGE FIELD -------- */}
                    <div className="imgfield" >
                        <input type="file" onChange={handleChange} accept="" />
                        <button onClick={() => handleUpload(file,percent)}>Upload to Firebase</button>
                        <p>{percent} "% done"</p>
                    </div>
                        {/* --------- TEXT FIELD -------- */}
                    <div className="textfield">
                            <TextField
                                onChange={(e) => setBlorboName(e.target.value)}
                                value = {blorboName.toString()}
                                required
                                fullWidth
                                id="input"
                                label="Character name"
                                multiline
                                name="input"
                                maxRows={4}
                            />
                    </div>
                    <div className="textfield">
                            <TextField
                                onChange={(e) => setBlorboOrigin(e.target.value)}
                                value = {blorboOrigin.toString()}
                                required
                                fullWidth
                                id="input"
                                label="Character origin"
                                multiline
                                name="input"
                                maxRows={4}
                            />
                    </div>
                    <div className="textfield">
                            <TextField
                                onChange={(e) => setBlorboOriginLink(e.target.value)}
                                value = {blorboOriginLink.toString()}
                                required
                                fullWidth
                                id="input"
                                label="Character origin link"
                                multiline
                                name="input"
                                maxRows={4}
                            />
                    </div>
                        <div className="textfield">
                            <TextField
                                onChange={(e) => setQuote(e.target.value)}
                                value = {quote.toString()}
                                required
                                fullWidth
                                id="input"
                                label="I like this character because..."
                                multiline
                                name="input"
                                maxRows={4}
                            />
                    </div>
                    
                    
                       
                    </Grid>
                    </Grid>
                    } 
                    

                {/* --------- SUBMIT -------- */}
                <Button
                onClick={()=>handleSubmit()}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                >
                Submit
                </Button>
                <Grid container justifyContent="flex-end">
                </Grid>
            </div>
        </div>
       
      );
}

export default AddMenu;